import classNames from 'classnames';
import type { IntlKey } from 'locales';
import type { AnalyticCategoryActions, WorkspaceAnalyticCategory } from 'models';
import type { ChangeEvent, ReactNode } from 'react';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

interface TradeActionsCustomCheckboxProps {
  id: string;
  isChecked: boolean;
  labelId: IntlKey;
  onChange(value: boolean): void;
  trackedEvent: AnalyticCategoryActions[WorkspaceAnalyticCategory];
  children?: ReactNode;
  isReadonly?: boolean;
}

export function TradeActionsCustomCheckbox({
  id,
  isChecked,
  labelId,
  onChange,
  trackedEvent,
  children,
  isReadonly = false,
}: TradeActionsCustomCheckboxProps) {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const onCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    logAnalytics.trackEvent(logAnalyticsCategory, trackedEvent);
    onChange(e.target.checked);
  };
  return (
    <div className="card border-start my-3">
      <div className="card-body ps-3 pe-0 py-0">
        <span className={classNames('form-check', { unclickable: isReadonly })}>
          <input
            id={id}
            className="form-check-input"
            type="checkbox"
            checked={isChecked}
            readOnly={isReadonly}
            onChange={onCheckboxChange}
          />
          <label className="form-check-label fs-6" htmlFor={id}>
            <FormattedMessage id={labelId} />
          </label>
        </span>
        {children}
      </div>
    </div>
  );
}
